import {
  Stack,
  Typography,
  TableContainer,
  Table as MUITable,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import { FC } from "react";
import { Loading } from "react-admin";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { useAffiliatePayouts } from "../../queries";
import { formatDate } from "@/utils";

const Payouts: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { affiliatePayoutsError, affiliatePayouts, isAffiliatePayoutsLoading } =
    useAffiliatePayouts({
      affiliateId: id || "",
    });

  if (isAffiliatePayoutsLoading) {
    return <Loading />;
  }

  if (affiliatePayoutsError) {
    return null;
  }

  return (
    <Stack width="40%">
      <Typography variant="h6" gutterBottom>
        Payouts
      </Typography>

      {affiliatePayouts.length > 0 ? (
        <Box sx={{ width: "100%" }}>
          <TableContainer>
            <MUITable size={"medium"}>
              <TableHead>
                <TableRow>
                  <TableCell>Month</TableCell>
                  <TableCell>Date of Payment</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {affiliatePayouts.map((payout, index) => {
                  const monthLabel = dayjs()
                    .year(payout.year)
                    .month(payout.month - 1)
                    .format("MMMM YYYY");

                  const paidLabel = formatDate(payout.paidAt, "DD.MM.YYYY");

                  const amount = (payout.amountCents / 100).toFixed(2);

                  return (
                    <TableRow
                      key={index}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell align="left">{monthLabel}</TableCell>
                      <TableCell align="left">{paidLabel}</TableCell>
                      <TableCell align="left">{amount}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </MUITable>
          </TableContainer>
        </Box>
      ) : (
        <Typography>No data</Typography>
      )}
    </Stack>
  );
};

export { Payouts };
